import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/apiClient";
import { RefreshCw, Sparkles, X } from "lucide-react";

// Banner "Nuova versione disponibile": confronta la revisione caricata all'avvio
// con quella servita dal backend; se cambia (dopo un deploy) invita a ricaricare.
export default function VersionBanner() {
  const initial = useRef(null);
  const [latest, setLatest] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const { data } = await api.get("/version");
        if (!data?.revision) return;
        if (initial.current == null) { initial.current = data.revision; return; }
        if (alive && data.revision !== initial.current) { setLatest(data); setDismissed(false); }
      } catch { /* offline: riprova al prossimo giro */ }
    };
    check();
    const timer = setInterval(check, 60000);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(timer); window.removeEventListener("focus", onFocus); };
  }, []);

  if (!latest || dismissed) return null;

  return (
    <div data-testid="version-banner"
      className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-terracotta/30 bg-terracotta/10 px-4 py-2.5 text-sm text-forest">
      <Sparkles className="h-4 w-4 shrink-0 text-terracotta" />
      <span className="font-medium">
        Nuova versione disponibile — rev. {latest.revision}{latest.date ? ` del ${latest.date}` : ""}
      </span>
      <span className="text-forest/70">L'app è stata aggiornata. Ricarica la pagina per usare l'ultima versione.</span>
      <button data-testid="version-reload" onClick={() => window.location.reload()}
        className="ml-auto inline-flex items-center gap-1.5 rounded-full bg-terracotta px-3.5 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-terracotta/90">
        <RefreshCw className="h-3.5 w-3.5" /> Ricarica
      </button>
      <button data-testid="version-dismiss" onClick={() => setDismissed(true)}
        className="rounded-full p-1 text-forest/50 transition-colors hover:bg-white/50 hover:text-forest" aria-label="Chiudi">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
